import React from "react";
import { Button } from "@revvsales/components";

const TogglePBStatusPopup = props => {
  const { active, name } = props.selectedPricelist;
  return (
    <div>
      <div className="pricingmethodwrapper-wrapper">
        <div className="pricingmethod-title">
          <span className="pricingmethodwrapper-header">
            {active ? "Deactivate " : "Activate "}
            Price Book
          </span>
        </div>
      </div>
      <div className="addpbitem-div-wrapper item-full-span">
        <div className="quotedelete-description">
          Do you want to {active ? "deactivate " : "activate "} price book,{" "}
          {name} ? <br />
          Your team will {active && "no longer "}
          be able to view/access this price book.
        </div>
      </div>
      <div className="aggridvisibilityctrl-footer">
        <div className="footer-actions">
          <Button
            className="btn btn-primary"
            type="button"
            onClick={props.togglePBActive}
            data-test="togglepbstatuspopup-btn">
            {active ? "Deactivate " : "Activate "}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TogglePBStatusPopup;



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricebookGrid/TogglePBStatusPopup.js